import { createFileRoute } from '@tanstack/react-router'
import { DriftDashboard } from '@/features/catalog/components/drift/drift-dashboard'

export const Route = createFileRoute('/_authenticated/command-center/drift')({
  component: DriftDashboard,
})
